<template>
    <div class="empty-state-box" :style="{paddingTop: padTop,width: width}">
        <!-- image="../assets/img/empty_state.png" -->
        <a-empty :image="require('../assets/img/empty_state.png')" :image-style="{height: imgHeight,}">
            <template slot="description">
                <span class="big-tip">{{bigTip}}</span><br/>
                <span class="sm-tip">{{smallTip}}</span>
            </template>
            <slot></slot>
        </a-empty>
    </div>
</template>

<script>
    export default {
        name: "EmptyState",
        props:{
            bigTip:{
                type:String,
                default:''
            },
            smallTip:{
                type:String,
                default:''
            },
            padTop:{
                type: String,
                default: '100%'
            },
            width:{
                type: String,
                default: '100%'
            },
            imgHeight:{
                type: String,
                default: '60px'
            }
        }
    }
</script>

<style lang="less" scoped>
    /*空狀態的樣式*/
    .empty-state-box{
        height: 100%;
        display: flex;
        justify-content: center;
    }
    .big-tip{
        color: #e6e6e6;
    }
    .sm-tip{
        font-size: 12px;color:#939393;
    }
</style>
